import {
  normalizeObjError,
  processName,
  USER_TYPES,
} from '@bit/gerenciatd.utils.ada-byron';
import { api } from '@bit/gerenciatd.utils.monitoring-utils';
import {
  Context,
  MethodType,
  UnknownObject,
  UnknownArray,
} from '@bit/gerenciatd.utils.types';
import { getUrlParams } from '@bit/gerenciatd.utils.common';
import Request, { getMockedInfo } from '@bit/gerenciatd.utils.request';
import Sonda from '@bit/gerenciatd.utils.sonda';

enum PATHS {
  GET_PRODUCT_EVALUATERULES = '/api/mov/products/evaluateRules',
  GET_ITEM = '/api/terminal/v1/getItem',
  GET_ALL_ITEMS = '/api/terminal/v1/getAllItem',
  GET_PRODUCT_CATEGORY = '/api/terminal/v1/getCategoryFusionInfo',
  GET_PRODUCTS_RECOM = '/perso/getRecommendation/productsCatalogue/GroupBy/ProdCategory',
  GET_ITEM_BY_ALIAS = '/api/terminals/getItemByAlias',
}

export const getProductEvaluateRulesSuccess = (
  xhr: XMLHttpRequest,
): UnknownObject => {
  const { response } = xhr;
  return JSON.parse(response);
};

export const getProductEvaluateRules = (
  data: {
    productList: {
      hiredSubProducts?: UnknownArray;
      parqueSearch?: boolean;
      productType?: string;
      viewType?: string;
      idType: string;
      product: string;
      infoRulesMap?: unknown;
    }[];
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { productList } = data;
  const idRequest = api.getUUID(idFront);
  const sonda = new Sonda({
    eventName: 'PAC.GET_PRODUCT_EVALUATERULES',
    context,
    uniqueId: idRequest,
    origin: processName,
  });

  const { catalogue: connectionData, name } = context.environment;
  const { endpoint: host, headers } = connectionData;

  const URL_API = `${host}${PATHS.GET_PRODUCT_EVALUATERULES}?${idRequest}`;

  const mockInfo = getMockedInfo('getProductEvaluateRules', name);

  /* normalizing input */
  const inputProducts = productList.map((item) => {
    const {
      hiredSubProducts,
      parqueSearch,
      productType,
      viewType,
      idType,
      product,
      infoRulesMap,
    } = item;

    return {
      hiredSubProducts: hiredSubProducts || [],
      parqueSearch: parqueSearch || false,
      productType: productType || undefined,
      viewType: viewType || 'none',
      idType,
      product,
      infoRulesMap: infoRulesMap || {},
    };
  });

  try {
    const request = new Request({
      method: MethodType.POST,
      endpoint: URL_API,
      data: inputProducts,
      onSuccess: (response: XMLHttpRequest) =>
        getProductEvaluateRulesSuccess(response),
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};

export const getItem = (
  data: {
    segment: string;
    alias: string;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { segment, alias } = data;
  const idRequest = api.getUUID(idFront);
  const sonda = new Sonda({
    eventName: 'PAC.TERMINAL.GET_ITEM',
    context,
    uniqueId: idRequest,
    origin: processName,
  });

  const { catalogue: connectionData, name } = context.environment;
  const { endpoint: host, headers } = connectionData;

  const URL_API = `${host}${PATHS.GET_ITEM}?${idRequest}&segment=${segment}&alias=${alias}`;

  const mockInfo = getMockedInfo('getItem', name);

  try {
    const request = new Request({
      method: MethodType.GET,
      endpoint: URL_API,
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};

/**
 * Llamada para recbir la informacion de los terminales de catalogo
 * @param {Object} data informacion para construir la url con los parametros especificos del endpoint
 * @param {Object} context contexto
 * @param {string} idFront id
 * @returns {object} Devuelve la respuesta de la llamada, null en caso de error
 */
export const getAllItem = (
  data: {
    segment: string;
    type: any;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { segment, type } = data;
  const idRequest = api.getUUID(idFront);
  const sonda = new Sonda({
    eventName: 'PAC.TERMINAL.GET_ALL_ITEM',
    context,
    uniqueId: idRequest,
    origin: processName,
  });

  const { catalogue: connectionData, name } = context.environment;
  const { endpoint: host, headers } = connectionData;
  let types = '';
  if (type && Array.isArray(type) && type.length > 0) {
    type.forEach((tipo) => {
      types += `&type=${tipo}`;
    });
  } else {
    types = `&type=${type}`;
  }

  const URL_API = `${host}${PATHS.GET_ALL_ITEMS}?${idRequest}&segment=${segment}${types}`;

  const mockInfo = getMockedInfo('getAllItem', name);

  try {
    const request = new Request({
      method: MethodType.GET,
      endpoint: URL_API,
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};

export const getProductCategory = (
  data: {
    customerType: string;
    prodCode: string;
  },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { customerType, prodCode } = data;
  const idRequest = api.getUUID(idFront);
  const sonda = new Sonda({
    eventName: 'PAC.TERMINAL.GET_PRODUCT_CATEGORY',
    context,
    uniqueId: idRequest,
    origin: processName,
  });

  const { catalogue: connectionData, name } = context.environment;
  const { endpoint: host, headers } = connectionData;

  const URL_API = `${host}${PATHS.GET_PRODUCT_CATEGORY}?${idRequest}&customerType=${customerType}&prodCode=${prodCode}`;

  const mockInfo = getMockedInfo('getProductCategory', name);

  try {
    const request = new Request({
      method: MethodType.GET,
      endpoint: URL_API,
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};

export const getProductsRecomError = (
  response: XMLHttpRequest,
  context: Context,
): UnknownObject => {
  const objError = normalizeObjError(response, context);

  // si el normalizador no consigue meter un response
  if (objError && !objError.response) {
    return {
      ...objError,
      response: {
        error: true,
      },
    };
  }

  return objError;
};

export const getProductsRecomSuccess = (xhr: XMLHttpRequest): UnknownObject => {
  const { response } = xhr;
  const data = JSON.parse(response);
  if (data) {
    return data;
  }
  return null;
};

export const getCustoUrlParams = () => {
  const urlParams = getUrlParams(true, [
    /levCode/g,
    /prodCode/g,
    /promoCode/g,
    /ctzTest/g,
  ]);

  const custoUrlParams = {
    promoCode: urlParams.promoCode || null,
    prodCode: urlParams.prodCode || null,
    levCode: urlParams.levCode || null,
    ctzTest: urlParams.ctzTest || null,
  };

  return custoUrlParams;
};

export const getProductsRecom = (
  context: Context,
  data: {
    viewType: unknown;
    prodContCode: unknown;
    faqs: unknown;
    product: unknown;
    subproducts: unknown;
  },
  idFront = 'VT',
): Promise<unknown> => {
  const idRequest = api.getUUID(idFront);

  const sonda = new Sonda({
    eventName: 'CUSTOMIZER.GET_PRODUCTS_RECOM',
    context,
    uniqueId: idRequest,
    origin: processName,
  });
  //webcode a pincho como malla de seguridad por si falla todo no mostrar
  // promos de no cliente a cliente
  let webCode = '';
  if (
    context &&
    context.contextURL &&
    context.contextURL.includes('/particulares/fusion/config')
  ) {
    webCode = 'web000565';
  }

  const {
    environment: { custo: connectionData, name },
    userType,
  } = context;

  const { endpoint: host, headers } = connectionData;
  const URL_API = `${host}${PATHS.GET_PRODUCTS_RECOM}?${idRequest}`;

  const mockInfo = getMockedInfo('getProductsRecom', name);

  const { viewType, prodContCode, faqs, product, subproducts } = data;
  const dataEntry = {
    ga: context.clientIDs && context.clientIDs.ga ? context.clientIDs.ga : '',
    pageId: (context.clientIDs && context.clientIDs.pageId) || 'sinPageId',
    session: (context.clientIDs && context.clientIDs.sessId) || null,
    url: context.contextURL,
    turingDev: context.turingDev,
    cutRecom: 1,
    cutAdditional: 1,
    cutAllProducts: 0,
    viewType: viewType || 'none',
    prodContCode: prodContCode,
    faqs: faqs,
    product: product,
    subproducts: subproducts,
    webCode: webCode,
  };

  if (userType === USER_TYPES.TGES) {
    dataEntry['filterType'] = userType;
  }

  const custoUrlParams = getCustoUrlParams();
  Object.keys(custoUrlParams).forEach((key) => {
    const custoVar = custoUrlParams[key];
    dataEntry[key] = custoVar;
  });

  try {
    const request = new Request({
      method: MethodType.POST,
      endpoint: URL_API,
      data: dataEntry,
      onError: (response: XMLHttpRequest) =>
        getProductsRecomError(response, context),
      onSuccess: (response: XMLHttpRequest) =>
        getProductsRecomSuccess(response),
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};

export const getItemByAliasError = (
  response: XMLHttpRequest,
  context: Context,
): UnknownObject => {
  const objError = normalizeObjError(response, context);

  // si el normalizador no consigue meter un response
  if (objError && !objError.response) {
    return {
      ...objError,
      response: {
        error: true,
      },
    };
  }

  return objError;
};

export const getItemByAliasSuccess = (xhr: XMLHttpRequest): UnknownObject => {
  const { response } = xhr;
  return JSON.parse(response);
};

export const getItemByAlias = (
  data: {
    segment: string;
    alias: string;
  },
  context: Context,
  idFront = 'webM',
): Promise<unknown> => {
  const idRequest = api.getUUID(idFront);
  const sonda = new Sonda({
    eventName: 'PAC.GET_ITEM_BY_ALIAS',
    context,
    uniqueId: idRequest,
    origin: processName,
  });

  const { catalogue: connectionData, name } = context.environment;
  const { endpoint: host, headers } = connectionData;

  const URL_API = `${host}${PATHS.GET_ITEM_BY_ALIAS}?${idRequest}`;

  const mockInfo = getMockedInfo('getItemByAlias', name);

  /* normalizing input */
  const input = {
    alias: data.alias,
    cat2: [data.segment],
  };

  try {
    const request = new Request({
      method: MethodType.POST,
      endpoint: URL_API,
      data: input,
      onSuccess: (response: XMLHttpRequest) => getItemByAliasSuccess(response),
      onError: (response: XMLHttpRequest) =>
        getItemByAliasError(response, context),
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};
